import { ProvinciaTipo } from './ProvinciaTipo';
import { ZonaTipo } from './ZonaTipo';
export class DepartamentoTipo{
    cdepartamento: number;
    codDepartamento: string;
    nombre: string;
    provinciaTipo: ProvinciaTipo;
    zonaTipo: ZonaTipo;
}
